/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IPropertyType } from './IPropertyType';
import {
    IPropertyTypeFromJSON,
    IPropertyTypeFromJSONTyped,
    IPropertyTypeToJSON,
} from './IPropertyType';
import type { IPropertyValue } from './IPropertyValue';
import {
    IPropertyValueFromJSON,
    IPropertyValueFromJSONTyped,
    IPropertyValueToJSON,
} from './IPropertyValue';
import type { ValueStorageType } from './ValueStorageType';
import {
    ValueStorageTypeFromJSON,
    ValueStorageTypeFromJSONTyped,
    ValueStorageTypeToJSON,
} from './ValueStorageType';

/**
 * 
 * @export
 * @interface IProperty
 */
export interface IProperty {
    /**
     * 
     * @type {number}
     * @memberof IProperty
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IProperty
     */
    key?: string;
    /**
     * 
     * @type {Date}
     * @memberof IProperty
     */
    createDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IProperty
     */
    updateDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IProperty
     */
    deleteDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IProperty
     */
    readonly hasIdentity?: boolean;
    /**
     * 
     * @type {ValueStorageType}
     * @memberof IProperty
     */
    valueStorageType?: ValueStorageType;
    /**
     * 
     * @type {IPropertyType}
     * @memberof IProperty
     */
    propertyType?: IPropertyType;
    /**
     * 
     * @type {Array<IPropertyValue>}
     * @memberof IProperty
     */
    values?: Array<IPropertyValue>;
    /**
     * 
     * @type {string}
     * @memberof IProperty
     */
    readonly alias?: string;
    /**
     * 
     * @type {number}
     * @memberof IProperty
     */
    readonly propertyTypeId?: number;
}

/**
 * Check if a given object implements the IProperty interface.
 */
export function instanceOfIProperty(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IPropertyFromJSON(json: any): IProperty {
    return IPropertyFromJSONTyped(json, false);
}

export function IPropertyFromJSONTyped(json: any, ignoreDiscriminator: boolean): IProperty {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'key': !exists(json, 'Key') ? undefined : json['Key'],
        'createDate': !exists(json, 'CreateDate') ? undefined : (new Date(json['CreateDate'])),
        'updateDate': !exists(json, 'UpdateDate') ? undefined : (new Date(json['UpdateDate'])),
        'deleteDate': !exists(json, 'DeleteDate') ? undefined : (new Date(json['DeleteDate'])),
        'hasIdentity': !exists(json, 'HasIdentity') ? undefined : json['HasIdentity'],
        'valueStorageType': !exists(json, 'ValueStorageType') ? undefined : ValueStorageTypeFromJSON(json['ValueStorageType']),
        'propertyType': !exists(json, 'PropertyType') ? undefined : IPropertyTypeFromJSON(json['PropertyType']),
        'values': !exists(json, 'Values') ? undefined : ((json['Values'] as Array<any>).map(IPropertyValueFromJSON)),
        'alias': !exists(json, 'Alias') ? undefined : json['Alias'],
        'propertyTypeId': !exists(json, 'PropertyTypeId') ? undefined : json['PropertyTypeId'],
    };
}

export function IPropertyToJSON(value?: IProperty | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'Key': value.key,
        'CreateDate': value.createDate === undefined ? undefined : (value.createDate.toISOString()),
        'UpdateDate': value.updateDate === undefined ? undefined : (value.updateDate.toISOString()),
        'DeleteDate': value.deleteDate === undefined ? undefined : (value.deleteDate.toISOString()),
        'ValueStorageType': ValueStorageTypeToJSON(value.valueStorageType),
        'PropertyType': IPropertyTypeToJSON(value.propertyType),
        'Values': value.values === undefined ? undefined : ((value.values as Array<any>).map(IPropertyValueToJSON)),
    };
}

